import find from "lodash/find";
import React from "react";
import Modal from "../../parts/modal-new";
import copy from "clipboard-copy";
import submit from "submit-form";

const AdminPassModal = ({ allUsers, user, api }) => {
  const [hash, setHash] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      const hash = await (
        await api(`create-admin-pass`, {
          method: "POST",
          body: { user },
        })
      ).json();
      setHash(hash.hash);
    };
    fetchData();
  }, []);

  const handleClose = async (e) => {
    e.preventDefault();
    await copy(hash);
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { modal: "", editMode: "" },
    });
  };

  const fullUser = React.useMemo(
    () => find(allUsers, ["_id", user]),
    [allUsers, user]
  );

  return (
    <Modal toClear={["user"]} width="750px" title="Temporary Password">
      <div className="body">
        <h3 className="mb-8">
          For {fullUser.name} - {fullUser.email}
        </h3>
        <div className="Admin-Pass">
          <span className="hash font-semibold">{hash}</span>
        </div>
      </div>
      <footer>
        <button type="submit" data-button-type="primary" onClick={handleClose}>
          Copy to clipboard and close
        </button>
      </footer>
    </Modal>
  );
};

export default AdminPassModal;
